import { render, staticRenderFns } from "./MarketDropdown.vue?vue&type=template&id=86e6beae&scoped=true"
import script from "./MarketDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./MarketDropdown.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MarketDropdown.vue?vue&type=style&index=0&id=86e6beae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86e6beae",
  null
  
)

export default component.exports